import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class PlatformServices {

  private destroyed: Subject<void> = new Subject();

  currentScreenSize: 'Tablet' | 'Handset' | 'Web' |  '' = '';

  private  screenChangesubject: BehaviorSubject< 'Tablet' | 'Handset' | 'Web' |  string> =  new BehaviorSubject( '');

  public screenChange = this.screenChangesubject.asObservable().pipe(filter( v => v !== ''));

  displayNameMap = new Map([
    ['(min-width: 600px) and (max-width: 839.98px) and (orientation: portrait)', 'Tablet'],
    ['(min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)', 'Tablet'],
    ['(max-width: 599.98px) and (orientation: portrait)', 'Handset'],
    ['(max-width: 959.98px) and (orientation: landscape)', 'Handset'],
    ['(min-width: 840px) and (orientation: portrait)', 'Web'],
    ['(min-width: 1280px) and (orientation: landscape)', 'Web'],
  ]);

  constructor( breakpointObserver: BreakpointObserver) {
    breakpointObserver
    .observe([
      Breakpoints.Tablet,
      Breakpoints.Handset,
      Breakpoints.Web
    ])
    .pipe(takeUntil(this.destroyed))
    .subscribe(result => {
      for (const query of Object.keys(result.breakpoints)) {
        if (result.breakpoints[query]) {
          this.currentScreenSize  =  this.displayNameMap.get(query) as  'Tablet' | 'Handset' | 'Web' |  '' ?? '';
          this.screenChangesubject.next(this.currentScreenSize );
        }
      }
    });
   }


}
